<template>
  <nav>
    <ol class="navigation-list" ref="list" :style="getPixelTransform">
      <li
        v-for="(item, index) in menuItems"
        :key="'menu-item-' + index"
        class="navigation-item"
        :style="getAppStyles(item, isActive && activeItemIndex === index)"
        :class="{
          'navigation-item--active': isActive && activeItemIndex === index,
        //  'navigation-item--active': isActive && item.imgUrl,
        }"
        ref="listItems"
      >
        <div
          v-if="svgMarkup[index]"
          class="navigation-item__icon"
          v-html="svgMarkup[index]"
        ></div>
        <!-- Ohne Titel gibt es KEINEN Balken: er traegt einen Blur-Effekt,
             und ein leerer Blurstreifen ueber dem Bild sieht nach Fehler aus
             (auf einer Kachel, die nur ihr Logo zeigt, genau so gesehen). -->
        <div
          v-if="getTitleText(item)"
          class="navigation-item__title"
          :style="getAppTitleStyles(isActive && activeItemIndex === index)"
        >
          {{ getTitleText(item) }}
        </div>
      </li>
    </ol>
    <!--<div id="custom" style="position: absolute; top: 200px; left: 100px; background-color: brown; border: 5px solid gray; padding: 2em; display: flex;">{{ getCustomLang() }}</div>-->
  </nav>
</template>

<script>
import { getLang } from '@/plugin/LangControl';
//import DeviceType from '../helpers/DeviceType';
import Device from '../helpers/Device';
import { isSvg } from '../helpers/ImageType';
import { loadSvg } from '../helpers/SvgCache';

export default {
  props: {
    menuItems: Array,
    activeItemIndex: Number,
    isActive: Boolean,
  },
  emits: {},
  data() {
    return {
      scrollPositionCounter: 0,
      visibleElements: 0,
      wrapperSize: 0,
      itemSize: 0,
      scrollOffset: 3,
      pixelOffset: 5,
      pixelTransform: 0,
      svgMarkup: {},
      getLang,
    };
  },
  mounted() {
    const pixelOffset = (window.innerWidth / 100) * this.pixelOffset;
    this.pixelOffset = pixelOffset;
    this.handleScrolling(this.activeItemIndex);
  },
  watch: {
    activeItemIndex(index) {
      this.handleScrolling(index);
    },
    menuItems: {
      immediate: true,
      handler() {
        this.loadTileSvgs();
      },
    },
  },
  methods: {
    getAppStyles(item, isActive) {
      const colorStyles = this.$store.getters['customizer/getAppStyles'](
        isActive
      );
      const itemIsSvg = isSvg(item.imgUrl);

      // Inline-SVG-Modus: SVG wird inline gerendert (currentColor), daher KEIN
      // background-image.
      if (this.isInlineMode && itemIsSvg) {
        return {
          ...colorStyles,
        };
      }

      const baseUrl = item.imgBaseUrl.length > 0 ? item.imgBaseUrl : process.env.PORTAL;

      // Raster (jpg/png/gif) fuellen die Kachel wie die VoD-Kacheln. SVG
      // bleibt bei 'contain': ein Logo darf nicht beschnitten werden.
      //
      // Wo das Bild BEGINNT, steht nicht mehr hier, sondern in der Klasse
      // (background-origin/-clip: border-box) - und zwar fuer beide Arten
      // gleich. Vorher galt fuer SVG das content-box der Klasse, also der um
      // das padding eingerueckte Innenbereich: zwischen Logo und Rahmen blieb
      // ein Streifen in der Hintergrundfarbe der Kachel stehen, bei
      // Rasterbildern nicht.
      return {
        ...colorStyles,
        backgroundImage: `url(${baseUrl + item.imgUrl})`,
        backgroundSize: itemIsSvg ? 'contain' : 'cover',
      };
    },
    // Der Kacheltitel in der aktiven Sprache, ohne Leerraum. Leer heisst:
    // kein Titelbalken (siehe Template).
    getTitleText(item) {
      const lang = getLang(item.lang) || {};
      return String(lang.title || '').trim();
    },
    getAppTitleStyles(isActive) {
      return this.$store.getters['customizer/getAppTitleStyles'](isActive);
    },
    loadTileSvgs() {
      if (!this.isInlineMode || !this.menuItems) {
        return;
      }
      this.menuItems.forEach((item, index) => {
        if (!isSvg(item.imgUrl)) {
          return;
        }
        const baseUrl =
          item.imgBaseUrl.length > 0 ? item.imgBaseUrl : process.env.PORTAL;
        loadSvg(baseUrl + item.imgUrl).then((markup) => {
          this.$set(this.svgMarkup, index, markup);
        });
      });
    },
    getSVGAppStyle(item, isActive) {
      const colorStyles = this.$store.getters['customizer/getAppSVGStyle'];

      return {
        ...colorStyles,
      };
    },
    getCustomLang(item) {
      const languages = this.$store.getters['customizer/getLanguage'];
      //language.filter((e) => e.show && e.show !== 'false').sort((a, b) => (a.position > b.position ? 1 : -1));
      /*return state.language
      .filter((e) => e.show && e.show !== 'false')
      .sort((a, b) => (a.position > b.position ? 1 : -1));*/
      //console.log("=================languages", languages);

      //if(languages) {
        //console.log("=================languages", languages.filter((e) => e.show && e.show !== 'false'));
      //}

      //var version = '';
      //if(window.tizenVersion) {
      //  version = window.tizenVersion;
      //}

      //int height,width;
      //system_info_get_platform_int("http://tizen.org/feature/screen.width", &width);
      //system_info_get_platform_int("http://tizen.org/feature/screen.height", &height);
      //var resolution = tizen.systeminfo.getPropertyValue("DISPLAY");

      //if(tizen.systeminfo) {
      //}

      //const device = this.$store.getters['device/getDeviceResolutionHeight']();
      //const device = this.$store.state.device;
      //const device = DeviceType.getResHeight;
      const resHeight = Device.resolutionHeight;
      const resWidth = Device.resolutionWidth;

      return {
        resHeight,
        resWidth,
        //...languages,
        //resolution,
        //version,
        //backgroundImage: `url(${baseUrl + item.imgUrl})`,
      };

    },
    handleScrolling(index) {
      if (this.$refs.listItems) {
        const itemNode = this.$refs.listItems[index];
        const spacingLeft = itemNode.getBoundingClientRect().x || itemNode.getBoundingClientRect().left;
        const spacingRight =
          window.innerWidth - (spacingLeft + itemNode.offsetWidth);
        if (spacingRight < this.pixelOffset) {
          this.pixelTransform += spacingRight - this.pixelOffset;
        } else if (spacingLeft < this.pixelOffset) {
          this.pixelTransform -= spacingLeft - this.pixelOffset;
        }
      }
    },
  },
  computed: {
    isInlineMode() {
      return this.$store.getters['customizer/getTileColorMode'] === 'inline';
    },
    getPixelTransform() {
      return {
        transform: `translateX(${this.pixelTransform}px)`,
      };
    },
  },
};
</script>

<style scoped>
.navigation-list {
  display: flex;
  justify-content: start;
  transition: transform 0.5s ease;
}

.navigation-item {
  /*aspect-ratio: 1/2;*/
  position: relative;
  box-sizing: border-box;
  color: #f1f1f1;
  font-weight: bold;
  font-size: 3vh;
  display: block;
  height: 20vh;
  /* Der Rahmen ist IMMER 5px breit. Sichtbar wird er nur im aktiven Zustand,
     denn seine Farbe kommt aus dem Customizer und ist inaktiv 'transparent'
     (customizer/getAppStyles). Vorher war er inaktiv 0px breit - beim
     Aktivieren schrumpfte dadurch der Innenbereich der Kachel und der
     Titelbalken sprang samt Text um 5px nach unten. */
  border-width: 5px;
  border-style: solid;
  background-position: center;
  background-repeat: no-repeat;
  /* Das Bild beginnt am AUSSENrand und liegt auch unter dem Rahmen. Sonst
     bleibt zwischen Bild und Rahmen ein Streifen in der Hintergrundfarbe der
     Kachel stehen - genau das war bei SVG-Logos zu sehen, waehrend
     Rasterbilder diesen Streifen nie hatten. Der frueher hier stehende
     Innenabstand (padding: 15px) ist damit wirkungslos geworden und
     entfallen; den Einzug der Inline-SVG-Icons traegt
     .navigation-item__icon weiter selbst. */
  background-origin: border-box;
  background-clip: border-box;
  background-size: contain;/*cover;*/
  flex: 0 0 30.5vh;
  margin-right: 1rem;
  text-align: center;
  width: 30.5vh;
}

/*
.navigation-item--active {
  box-sizing: border-box;
  color: #f1f1f1;
  font-weight: bold;
  font-size: 3vh;
  display: block;
  height: 20vh;
  border-width: 5px;
  border-style: solid;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex: 0 0 30vh;
  margin-right: 1rem;
  text-align: center;
  width: 30vh;
}
*/

/* Inline-SVG-Ebene: fuellt die Kachel, SVG erbt die Bildfarbe via currentColor.
   Liegt hinter dem Titel (position/z-index), damit der Titel lesbar bleibt.
   Ohne Innenabstand, damit ein inline gerendertes Logo genauso weit reicht wie
   dasselbe Logo als background-image - welcher der beiden Wege greift, haengt
   nur daran, ob im Customizer eine Icon-Farbe steht, und darf am Bild nichts
   aendern. Das SVG skaliert dabei ueber sein viewBox-Verhaeltnis (mittig,
   nichts wird beschnitten). */
.navigation-item__icon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  color: currentColor;
}

/* Titelbalken: am INNENrand des Rahmens ausgerichtet, nicht im Inhaltsbereich.
   Absolut positioniert, damit er weder vom padding eingerueckt wird noch vom
   Rahmen verschoben - zusammen mit der festen Rahmenbreite oben bleibt er in
   jedem Zustand an derselben Stelle. */
.navigation-item__title {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  line-height: 100%;
  padding-top: 2%;
  height: 4vh;
  overflow: hidden;
  backdrop-filter: blur(20px);
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue